module.exports = __webpack_public_path__ + "img/course107.3b4ed87e.png";